<template>
  <input-base
    :overlap="overlap"
    :small="small"
    :transparent="transparent"
    :stretched="stretched"
    :slimmer="slimmer"
    :squished="squished">

    <label
      slot="label"
      v-if="!!inputLabel"
      :for="inputName">

      {{ inputLabel }}
    </label>


  <div
    slot="input"
    class="rt-options-container">

    <textarea
      :form="parentForm"
      :class="`${getInnerStyle} ${className}`"
      :id="identification"
      :name="inputName"
      :placeholder="getPlaceholderLabel"
      :ref="taRef"
      v-model="value"
      @focus="setCursorLoc"
      @keypress="textAreaAdjust(taRef)" />

    <rt-options
      class="rt-options"
      @insertEmoji="insertEmoji"
      v-if="rich" />

    </div>
  </input-base>
</template>

<script>
import InputBase from '@/components/standard/input/InputBase'
import RichTextOptions from '@/components/standard/input/RichTextOptions'
import stylers from '@/mixins/components/standard/input/inputButton/stylers'
import '@/assets/styles/standardInputs.css'
import uuidv1 from 'uuid/v1'
import inputValidator from '@/mixins/standard/input/inputValidator'

let taRef = uuidv1()

export default {
  data () {
    return {
      lastCursorLoc: -1,
      updateCursor: true,
      value: this.inputValue,
      taRef: taRef
    }
  },

  methods: {
    /**
     * Sets cursor's location
     */
    setCursorLoc () {
      this.$emit("focus", {focused: true})

      this.updateCursor = true
      this.lastCursorLoc = -1
    },

    /**
     * Inserts emoji to textarea
     * @param {Object} e Emoji object
     */
    insertEmoji(e) {
      let cursorLocation = this.$refs[this.taRef]
      let index = cursorLocation.selectionStart
      if (this.updateCursor) {
        this.lastCursorLoc = index
        this.updateCursor = false
      } else {
        // Emoji takes 2 characters.
        this.lastCursorLoc += 2
      }

      index = (this.lastCursorLoc !== -1) ? this.lastCursorLoc : index

      let p1 = this.value.substring(0, index)
      let p2 = this.value.substring(index)
      this.value = `${p1}${e.emoji}${p2}`
      this.sendUpdate()
    },

    /**
     * Adjusts text-area to fit content
     * @param {String} taRef
     */
    textAreaAdjust (taRef) {
      let ta = this.$refs[taRef] || { style: {} }

      ta.style.height = '1px'
      ta.style.height = (25 + ta.scrollHeight) + 'px'
    }
  },

  computed: {
    /**
     * Gives input's value
     * @returns {String}
     */
    getInputValue () {
      return this.value
    }
  },

  components: {
    'rt-options': RichTextOptions,
    'input-base': InputBase
  },

  watch: {
    inputValue: function(old, newV) {
      this.$set(this, 'value', this.inputValue)
      this.textAreaAdjust(this.taRef)
    },
    value: function (oldValue, newValue) {
      this.sendUpdate()
    }
  },

  props: {
    rich: {
      type: Boolean,
      required: false,
      default: false
    },
    stripped: {
      type: Boolean,
      required: false,
      default: false
    },
    inputValue: {
      type: String,
      required: false,
      default: ''
    },
    parentForm: {
      type: String,
      required: false
    }
  },

  mixins: [
    inputValidator,
    stylers
  ]
}
</script>

<style scoped>
textarea {
  min-height: 180px;
  width: 100%;
  outline: 0;
  border-radius: 3px;
  font-size: 14px;
  font-weight: normal;
  transition: font-size .3s;
}
.danger {
  color: rgba(255, 50, 100, 0.7)
}
.tight {
  padding: 0;
  margin: 0;
}
.fancy {
  border-bottom: 2px solid #1E1E1E;
}
.shady {
  box-shadow: 0 0 1px rgba(30, 30, 30, 0.315);
  transition: box-shadow 0.3s;
}
.shady:hover {
  box-shadow: 0 0 3px rgba(30, 30, 30, 0.59);
}
.shady:focus {
  box-shadow: 0 0 5px rgba(30, 30, 30, 1);
}
.stripped {
  resize: none;
  border-bottom: none;
}
.fancy:focus {
  border-bottom: 2px solid greenyellow;
}
.larger {
  font-size: 24px;
  font-weight: bold;
}
.smaller {
  font-size: 14px;
  font-weight: normal;
}
.tighter {
  padding: 3px 7px;
  font-size: 10px;
  color: #1E1E1E;
  width: auto;
}
.taller {
  height: 300px;
}

.sqwiz-title {
  padding: 0 12px!important;
  margin: 10px 0!important;
  color: #333333;
  font-size: 23px;
  line-height: 32px;
  font-weight: initial!important;
}
.sqwiz-content {
  padding: 0 12px!important;
  color: #666666;
  font-size: 17px;
  line-height: 27px;
  font-weight: initial!important;
}

.sqwiz-product-title {
  font-size: 19px;
  font-weight: 400;
  color: rgb(51, 51, 51);
}

.plain {
  border: 0!important;
  padding: 0!important;
  resize: none;
}

.rt-options {
  position: relative;
  top: -7px;
}

</style>




// WEBPACK FOOTER //
// src/components/standard/input/InputTextarea.vue?062ba058